<template>
  <div class="balancing-approval-history-item">
    <p v-if="!cycles.length" class="text-muted mb-0 font-size-13">
      {{ $t('sale_notes.resumes.there is no data yet') }}
    </p>
    <template v-else>
      <div v-for="(cycle, cycleIndex) in cycles" :key="cycle.id" class="cycle-block my-2">
        <b-link
            class="cycle-header"
            href="#"
            @click.prevent="toggleCycle(cycle.id)"
        >
          <span class="cycle-title">{{ cycleLabel(cycleIndex) }}</span>
          <span class="cycle-date">{{ formattedSubmittedAt(cycle) }}</span>
          <span class="flex-grow-1"></span>
          <status-badge
              :status="cycle.status"
              entity="balancing_approval"
              type="status"
          ></status-badge>
          <i :class="isCycleOpen(cycle.id) ? 'bx bx-chevron-up' : 'bx bx-chevron-down'"></i>
        </b-link>
        <b-collapse v-model="openCycles[cycle.id]" :id="`balancing-approval-cycle-${cycle.id}`">
          <div class="cycle-body">
            <template v-for="(step, stepIndex) in cycleSteps(cycle)">
              <approval-progress-step
                  :key="stepKey(cycle, step, stepIndex)"
                  :is-last="stepIndex === cycleSteps(cycle).length - 1"
                  :step="step"
              />
            </template>
          </div>
        </b-collapse>
      </div>
    </template>
  </div>
</template>

<script>
import ApprovalProgressStep from '@/components/purchase-plans/approval-progress-step.vue'
import StatusBadge from '@/components/badges/status-badge.vue'
import {collapseApprovalProgressSteps} from '@/utils/balancing_approval/approvalProgress'

export default {
  name: 'balancing-approval-history',
  components: {
    ApprovalProgressStep,
    StatusBadge,
  },
  props: {
    saleOrder: {
      type: Object,
      required: true,
    },
    initialOpenCycleId: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      openCycles: {},
    };
  },
  computed: {
    cycles() {
      return Array.isArray(this.saleOrder.balancing_approval_cycles) ? this.saleOrder.balancing_approval_cycles : []
    },
  },
  created() {
    this.initOpenCycles()
  },
  methods: {
    initOpenCycles() {
      const openCycles = {}
      this.cycles.forEach((cycle) => {
        const isTarget = this.initialOpenCycleId != null && `${cycle.id}` === `${this.initialOpenCycleId}`
        openCycles[cycle.id] = !!cycle.is_latest || isTarget
      })
      this.$set(this, 'openCycles', openCycles)
    },
    cycleSteps(cycle) {
      return collapseApprovalProgressSteps(cycle?.approval_progress?.steps)
    },
    stepKey(cycle, step, index) {
      const historyId = step?.history?.id ?? 'no-history'
      return `balancing-approval-cycle-${cycle.id}-step-${step?.level ?? index}-${historyId}`
    },
    cycleLabel(cycleIndex) {
      const n = this.cycles.length - cycleIndex
      return this.$t('balancing_approvals.cycle_label', {n})
    },
    formattedSubmittedAt(cycle) {
      return cycle?.submitted_at ? this.$moment(cycle.submitted_at).format('DD MMM YYYY') : '-'
    },
    isCycleOpen(cycleId) {
      return !!this.openCycles[cycleId]
    },
    toggleCycle(cycleId) {
      this.$set(this.openCycles, cycleId, !this.openCycles[cycleId])
    },
  },
}
</script>

<style lang="scss" scoped>
.balancing-approval-history-item {
  & + .balancing-approval-history-item {
    margin-top: 16px;
    padding-top: 16px;
    border-top: 1px solid #E5E7EB;
  }
}

.cycle-block {
  border: #D0D5DD 1px solid;
  border-radius: 8px;
  overflow: hidden;
}

.cycle-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px;
  color: #171717;
  font: 600 13px/18px Inter;


  &:hover, &:focus {
    color: #171717;
    text-decoration: none;
  }
}

.cycle-date {
  font: 400 12px/16px Inter;
  color: #6C7589;
}

.cycle-body {
  background-color: #F9FAFB;
  padding: 8px;
  border-top: 1px solid #E5E7EB;
}
</style>
